export const FILTER_ID_PLP_TOP = "filter-plp-top";
export const FILTER_ID_PLP_BOTTOM = "filter-plp-bottom";
export const FILTER_ID_PDP = "filter-pdp-bottom";
